import { render, staticRenderFns } from "./ProfileMainSection.vue?vue&type=template&id=01c01eba"
import script from "./ProfileMainSection.vue?vue&type=script&lang=js"
export * from "./ProfileMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopProfilesMyProfile: require('/app/components/Theme2/Desktop/Profiles/MyProfile.vue').default,Theme2DesktopProfilesBankDetail: require('/app/components/Theme2/Desktop/Profiles/BankDetail.vue').default,Theme2DesktopProfilesMyMessage: require('/app/components/Theme2/Desktop/Profiles/MyMessage.vue').default,Theme2DesktopProfilesMyHistory: require('/app/components/Theme2/Desktop/Profiles/MyHistory.vue').default,Theme2DesktopProfilesResetPassword: require('/app/components/Theme2/Desktop/Profiles/ResetPassword.vue').default,Theme2DesktopProfilesReferFriend: require('/app/components/Theme2/Desktop/Profiles/ReferFriend.vue').default,Theme2DesktopProfilesGameHistory: require('/app/components/Theme2/Desktop/Profiles/GameHistory.vue').default,Theme2DesktopProfilesMyBonus: require('/app/components/Theme2/Desktop/Profiles/MyBonus.vue').default,Theme2DesktopProfilesWithdrawalPage: require('/app/components/Theme2/Desktop/Profiles/WithdrawalPage.vue').default,Theme2DesktopProfilesDepositPage: require('/app/components/Theme2/Desktop/Profiles/DepositPage.vue').default})
